import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

import Section from '../Section/Section'
import colors from '../../colors'
import { useState } from 'react'

const Nav = styled.div`
    display: flex;
    padding: 20px;
    border-bottom: 3px solid  ${colors.orange};
    background:  ${colors.darkgrey};
    align-items: center;

    svg {display: none;}

    @media only screen and (max-width: 800px) {
        svg {display: inherit;}
    }

    
`

const Menu = styled.div`
    display: flex;
    align-items: center;

    @media only screen and (max-width: 800px) {
        position:absolute;
        left: 0px;
        top: 76px;
        width:100%;
        background:  ${colors.darkgrey};
        display: ${props => props.show ? 'none' : 'flex'};

       
    }

    
`

const Title = styled.h1`
    display: flex;
    color:  ${colors.lightgrey};
    font-family: BankGothic;
    margin: 0px;
    flex-grow: 3;
`

const LinkContainer = styled.div`
    display: flex;
    flex: 2;
    justify-content: right;
    margin-right: 20px;
    align-items: center;
    a {
        padding: 0px 20px;
        display: flex;
        color:${colors.lightgrey};
        text-decoration: none;
        font-weight: bold;
    }

    @media only screen and (max-width: 800px) {
        flex-direction: column;
        margin: 0px;
        border-bottom: 3px solid  ${colors.orange};

        a{
            padding: 20px;
        }
    }
   
`


const Navigation = () => {

    const [showMenu, setShowMenu] = useState(true)

    const menuHandler = () =>{
        setShowMenu(!showMenu)
    }

    

    return (
        <Nav>
            <Section style={{maxWidth: '1056px'}}>
                <Title>RYKLIN OY</Title>

                <FontAwesomeIcon onClick={menuHandler} style={{color: `${colors.lightgrey}`, fontSize: '30px', cursor: 'pointer'}} icon={faBars} />
                    
                <Menu show={showMenu}>
                   <LinkContainer>
                        <a href="#kunnossapito">Kunnossapito</a>
                        <a href="#maanrakennus">Maanrakennus</a>
                        <a href="#maataloudenurakointi">Maatalousurakointi</a>
                        <a href="#yhteys">Yhteys</a>
                    </LinkContainer>
                </Menu>
            </Section>
        </Nav>
    )
}

export default Navigation